import React, { Component } from 'react';
import { get } from '../../utils/networking'
import CheckInPopup from '../checkInPopup'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

const Headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
}


export default class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resourcesShow: false,
            helpShow: false,
            businessShow: false,
            aboutShow: false,
            footerMenu: [],
            isShowCheckInPopup: false,
            profile: {},
            currentStore: null
        }
    }

    handleSignUpClick() {
        const email = this.refs.email.value
        var regExp = new RegExp("[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$")

        if (!regExp.test(email))
            return

        get('user/subscribe/' + encodeURIComponent(email), "customer", result => {
            alert("Subcribe success")
        }, errors => {
            alert("Subcribe fail")
        })
    }
    postDomain(api, body) {
        const response = fetch('https://api.nailspaofamerica.com/' + api, {
            method: 'GET',
            headers: Headers,
            body: JSON.stringify(body)
        })
        return response
    }
    getSubItem() {
        this.postDomain('api/web/footer')
            .then(response => {
                if (response.status === 200) {
                    response.json()
                        .then(result => {
                            this.setState({
                                footerMenu: result
                            })
                        })
                } else {
                    alert("Can't load footer data")
                }
            })
            .catch(err => {
                alert("Can't connect to server")
            })
    }
    handleGetProfile(callback) {
        get('user/getMyProfile', "customer", result => {
            this.setState({
                profile: result,
                currentStore: result.stores[0]
            })
        }, () => callback())
    }
    componentDidMount() {
        this.getSubItem()
    }
    render() {
        let bottomFooter1 =
        {
            text: "© 2017 nailspaofamerica.com, Inc. All Rights Reserved. Designated trademarks and brands are the property of their respective owners.",
            label: "Legal Notices",
            link: "/pages/legal-notice/"
        }
        let bottomFooter2 =
        {
            text: "Though we strive to provide accurate information, nailspaofamerica.com is not responsible for any errors in any property listing or any offers advertised by any property. We encourage you to verify all such information with each property. Please report to nailspaofamerica.com any errors that you find."
        }
        let menuSocial = [
            {
                icon: "fa fa-facebook",
                link: "#"
            },
            {
                icon: "fa fa-twitter",
                link: "#"
            },
            {
                icon: "fa fa-pinterest-p",
                link: "#"
            },
            {
                icon: "fa fa-google-plus",
                link: "#"
            }
        ]
        let menuFooter1 = this.state.footerMenu.sort((a, b) => { return (a.id - b.id) })

        let {
            isShowCheckInPopup,
            profile,
            currentStore
        } = this.state;
        return (
            <footer>
                <CheckInPopup
                    profile={profile}
                    currentStore={currentStore}
                    isShow={isShowCheckInPopup}
                    cancel={() => this.setState({ isShowCheckInPopup: false })}
                    changeCurrentStore={(store) => this.setState({ currentStore: store })} />
                <div className="border_line_bottom">
                    <div className="container">
                        <div className="content clearfix">
                            {menuFooter1.map((item, key) =>
                                <div className="col_2 col_sm_12" key={key}>
                                    <div className="accordion_box">
                                        <NavLink to="" className="click_open">{item.name}</NavLink>
                                        <ul className="sub-menu">
                                            {item.footers.map((i, index) =>
                                                <li key={index}><a href={i.link}>{i.title}</a></li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            )}
                            <div className="col_4 col_sm_12">
                                <div className="newsletter">
                                    <h3>Sign Up for Newsletters</h3>
                                    <h4>Get tips, exclusive offers and more!</h4>
                                    <div className="gf_browser_safari gf_browser_iphone gform_wrapper" id="gform_wrapper_14">
                                        <div className="gform_body">
                                            <ul>
                                                <li><input placeholder="Enter Email Address" ref="email" /></li>
                                                <li>
                                                    <button type="submit" className="green large" onClick={() => this.handleSignUpClick()}>Sign Up</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright">
                        <div className="clearfix">
                            <div className="col_9 col_sm_12 first">
                                <p>{bottomFooter1.text} <NavLink to="/pages/legal-notice/" rel="nofollow"
                                    className="legal">{bottomFooter1.label}</NavLink></p>
                                <p className="disclaimer">{bottomFooter2.text}</p>
                            </div>
                            <div className="col_3 col_sm_12 last">
                                {menuSocial.map((item, i) =>
                                    <NavLink key={i} to={item.link} className="footer-icon"><i className={item.icon} aria-hidden="true"></i></NavLink>)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="user_footer">
                    {
                        (window.localStorage.getItem("access_token")) ? <ul className="left_menu">
                            <li>
                                <NavLink to="/user/overview">
                                    <i className="fas fa-eye" aria-hidden="true"></i>
                                    <p>Overview</p>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink to="/user/appointment" >
                                    <i className="far fa-calendar-alt" aria-hidden="true"></i>
                                    <p>My appointment</p>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink to="/user/reward">
                                    <i className="fa fa-trophy" aria-hidden="true"></i>
                                    <p>Rewards</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/user/setting">
                                    <i className="fa fa-user-o" aria-hidden="true"></i>
                                    <p>Profile Settings</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/user/referral">
                                    <i className="fa fa-sitemap" aria-hidden="true"></i>
                                    <p>Referral</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="#" onClick={() => this.handleGetProfile(this.setState({ isShowCheckInPopup: true }))}>
                                    <i className="far fa-check-circle"></i>
                                    <p>Check in</p>
                                </NavLink>
                            </li>
                        </ul> : ""
                    }
                </div>
            </footer >
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/footer/index.js